import Backend from './Backend';
import { stringify } from 'query-string';

export default (url, params) => {

  const options = {
    headers: { 'Accept': 'application/json' }
  }

  const queryParams = stringify(params);

  return Backend.abortableGet.call(null, `${url}?${queryParams}`, options);
};
